import { whenever } from '@vueuse/core';
import { isWsConnected } from '@/core/oddsApi/apollo';
import { useMetadataSubscription } from '@/core/oddsApi/oddsApiType';

/**
 * Subscribe to metadata once and auto-stop after receiving data
 */
export function useMetadataOnce() {
    const { onSubscription, stop, start } = useMetadataSubscription(
        {},
        { enabled: true },
    );

    onSubscription((data) => {
        if (data) {
            stop();
        }
    });

    whenever(isWsConnected, () => {
        start();
    });
}
